import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class KeyIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          d='M16.000,16.000 L13.000,16.000 L11.000,14.000 L11.000,13.000 L10.000,13.000 L9.000,12.000 L9.000,11.000 L8.000,11.000 L7.000,10.000 L7.000,9.578 C6.387,9.846 5.712,10.000 5.000,10.000 C2.239,10.000 -0.000,7.761 -0.000,5.000 C-0.000,2.239 2.239,0.000 5.000,0.000 C7.761,0.000 10.000,2.239 10.000,5.000 C10.000,5.595 9.878,6.158 9.687,6.687 L16.000,13.000 L16.000,16.000 ZM3.500,2.000 C2.672,2.000 2.000,2.672 2.000,3.500 C2.000,4.328 2.672,5.000 3.500,5.000 C4.328,5.000 5.000,4.328 5.000,3.500 C5.000,2.672 4.328,2.000 3.500,2.000 Z'/> ]
  getViewBox = () => '0 0 16 16'
}
